import React from 'react';

import { currencyString } from '@consumer-frontend/nc-utils';

import '@consumer-bootstrap/netcredit.scss';

export type NcFullPayoffAmountPropsT = {
  amount?: number;
  isCalledDue?: boolean;
  isDisabled?: boolean;
};
export type NcFullPayoffAmountT = React.FC<NcFullPayoffAmountPropsT>;

export const fullPayoffHelperText = 'Amount changes based on the payment date you select.';

export const selectDateText = 'Select a payment date to calculate full payoff amount.';

export const NcFullPayoffAmount: NcFullPayoffAmountT = (
  {
    amount,
    isCalledDue,
    isDisabled,
  },
) => {
  const finePrint = amount ? fullPayoffHelperText : selectDateText;

  return (
    <p className="payment-amount-option-label">
      <span>Full payoff amount</span>
      {!!amount && !isDisabled && <span className="currency-amount">{currencyString(amount)}</span>}

      {!isCalledDue && <span className="fine-print">{finePrint}</span>}
    </p>
  );
};
